<template>
  <v-text-field outlined dense hide-details :value="value" v-on="$listeners" data-qa="filter-search">
    <template v-slot:prepend-inner>
      <v-icon size="16px" color="#8a9eb1">icon-search</v-icon>
    </template>
    <template v-slot:label class="search-label">
      <span class="label-container">
        <span class="search-label">{{placeholder}}</span>
      </span>
    </template>
  </v-text-field>
</template>

<script>
  export default {
    name: "FilterSearch",
    props: {
      value: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      }
    },
  };
</script>

<style lang="scss" scoped>
  .label-container {
    position: relative;
    top: -8px;
  }

  .search-label {
    line-height: 30px;
    font-family: var(--primary-font-family);
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #8a9eb1;
  }
</style>
